import omit from 'lodash/omit';

import Grid from '@mui/material/Grid';

import ReportFilters from './ReportFilters';
import ReportTable from './ReportTable';

const allowedFilters = [
  {
    filterName: 'provider_id',
    queryParam: 'id',
  },
  {
    filterName: 'facility_id',
    queryParam: 'facility__id',
  }
];

const WeeklyProviderActuationSummaryReport = ({
  reportData, 
  filter,
  onFilterChange
}) => {
  const tableData = reportData?.data?.[0];
  return (
    <>
      <Grid container>
        <ReportFilters
          filter={filter}
          allowedFilters={allowedFilters}
          onFilterChange={onFilterChange}
        />
      </Grid>
      <ReportTable
        title={tableData?.name || ''}
        columns={tableData?.columns || []} 
        rows={tableData?.rows || []}
      />
    </>
  );
};

export default WeeklyProviderActuationSummaryReport;